<template>
  <div v-if="model.edit">
    <div v-if="!model.edit.$model">
      <div v-html="model.recipientHTML.$model" />

      <button v-if="model.edit" class="btn btn-primary" @click="editRecipient(true)">Edytuj</button>
    </div>

    <div v-else>
      <w-input class="mt-2" :model="model.directorName" />

      <w-input class="mt-2" :model="model.school.schoolName" />

      <address-picker class="mt-2" :model="model.school.schoolAddress" />

      <button class="btn btn-primary mt-2" @click="editRecipient(false)">Podgląd</button>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import AddressPicker from '../../../formComponents/AddressPicker';

// @vuese
// Formularz adresata
// @group ActionData
export default {
  components: { ...components, AddressPicker },
  props: {
    // schema
    model: { type: Object, required: true }
  },
  methods: {
    // @vuese
    // Edytuj adresata
    editRecipient(val) {
      this.model.edit.$setData(val);
    }
  }
};
</script>
